<template>
  <div class="reply-keyboard-item keyboard-item action-item shadow">
    <BasicInput v-model="item.text" placeholder="Text" class="half-input" />
    <BasicInput v-model="item.callback_data" placeholder="Action" class="half-input" />
    <span @click="deleteItem"><Trash /></span>
  </div>
</template>

<script>
import Trash from '@/components/icons/Trash'
import BasicInput from '@/components/inputs/BasicInput'

export default {
  props: ['index', 'item'],
  components: {BasicInput, Trash},
  methods: {
    deleteItem() {
      this.$emit('deleteItem', this.index)
    }
  }
}
</script>